// import Api from '../api'
import axios from 'axios'
import globalKey from './globalKey'
export default ({
  state: {
  },
  mutations: {
  },
  actions: {
    exportToPdf({commit}, data) {
      axios({
        url: globalKey + '/fileDownload' + '/' + data.type + '/' + data.id + '/' + data.report + '/' + this.getters.organisationId + '/' + this.getters.userId,
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = data.report + 'invoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/globalReport.js